import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { Route } from 'react-router-dom'
import { getThreads } from 'store/Discussion/actions'
import Discussions from './components'
import Comments from '../Comments'
import CreateDiscussion from './components/CreateDiscussion'
import { fetchUser } from 'store/Users/actions'

const Discussion = (props) => {
  const dispatch = useDispatch()
  const { filter, threads } = useSelector((state) => state.discussion)
  const user = useSelector((state) => state.auth.user)
  const comments = useSelector((state) => state.comments)
  const language = useSelector((state) => state.language)

  useEffect(() => {
    dispatch(getThreads())
    dispatch(fetchUser(user.id))
  }, [dispatch, user.id])

  const list = threads.filter(
    (item, index) =>
      item.title.toLowerCase().indexOf(filter.toLowerCase()) !== -1
  )
  const { access } = user

  return (
    <div>
      <Route
        exact
        path='/discussions'
        render={() => (
          <Discussions
            access={access}
            list={list}
            len={list.length}
            language={language}
          />
        )}
      />

      <Route
        exact
        path='/discussions/:id/comments'
        render={(routeProps) => {
          return (
            <Comments
              list={comments?.list}
              threads={threads}
              searchValue={comments.searchValue}
              language={language}
              access={user.access}
              {...routeProps}
            />
          )
        }}
      />

      <Route
        exact
        path='/discussions/create'
        render={() => (
          <CreateDiscussion
            access={access}
            list={list}
            len={list.length}
            language={language}
          />
        )}
      />
    </div>
  )
}

export default Discussion
